var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPagination
    ? _c("nav", { staticClass: "gobierto-pagination" }, [
        _c(
          "button",
          {
            staticClass: "gobierto-pagination-btn",
            attrs: { disabled: _vm.disabledPrevButton },
            on: { click: _vm.prevPage }
          },
          [_vm._v("\n    " + _vm._s(_vm.labelPrev) + "\n  ")]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "gobierto-pagination-pages" },
          _vm._l(_vm.paginationOptions, function(pageNumber) {
            return _c(
              "li",
              {
                key: pageNumber,
                staticClass: "gobierto-pagination-pages-element"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "gobierto-pagination-pages-element-btn",
                    attrs: { disabled: pageNumber === _vm.page },
                    on: {
                      click: function($event) {
                        return _vm.currentPage(pageNumber)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(pageNumber) + "\n      ")]
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "gobierto-pagination-btn",
            attrs: { disabled: _vm.disabledNextButton },
            on: { click: _vm.nextPage }
          },
          [_vm._v("\n    " + _vm._s(_vm.labelNext) + "\n  ")]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }